

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedOptions: {},
  selectedSku: null,
};

const variantSlice = createSlice({
  name: "variant",
  initialState,

  reducers: {
    selectVariant(state, action) {
      const { variantName, optionId, productSku } = action.payload;

      state.selectedOptions[variantName] = optionId;

      const selectedIds = Object.values(state.selectedOptions);

      const matchedSku = Object.values(productSku || {}).find((sku) => {
        const skuOptionIds = sku.productSkuOptionsList.map(
          (o) => o.categoryVariantOptionId
        );

        const sameLength =
          skuOptionIds.length === selectedIds.length;

        const allMatch = selectedIds.every((id) =>
          skuOptionIds.includes(id)
        );

        const inStock = sku.stock > 0;

        return sameLength && allMatch && inStock;
      });

      state.selectedSku = matchedSku || null;
    },

    setInitialSku(state, action) {
      state.selectedSku = action.payload.sku;
      state.selectedOptions = action.payload.selectedOptions;
    },

    resetSelectedVariant(state) {
      state.selectedOptions = {};
      state.selectedSku = null;
    },
  },
});

export const variantAction = variantSlice.actions;
export default variantSlice;


// import { createSlice } from "@reduxjs/toolkit";

// const initialState = {
//   selectedOptions: {},              // KEEP (SKU logic)
//   selectedOptionsWithValues: {},   // NEW (UI values)
//   selectedSku: null,
// };

// const variantSlice = createSlice({
//   name: "variant",
//   initialState,

//   reducers: {
//     selectVariant(state, action) {
//       const { variantName, optionId, option, productSku } = action.payload;

//       // =========================
//       // 1. SKU LOGIC (UNCHANGED)
//       // =========================
//       state.selectedOptions[variantName] = optionId;

//       const selectedIds = Object.values(state.selectedOptions);

//       const matchedSku = Object.values(productSku || {}).find((sku) => {
//         const skuOptionIds = sku.productSkuOptionsList.map(
//           (o) => o.categoryVariantOptionId
//         );

//         const sameLength =
//           skuOptionIds.length === selectedIds.length;

//         const allMatch = selectedIds.every((id) =>
//           skuOptionIds.includes(id)
//         );

//         const inStock = sku.stock > 0;

//         return sameLength && allMatch && inStock;
//       });

//       state.selectedSku = matchedSku || null;

//       // =========================
//       // 2. UI VALUE STORE (NEW)
//       // =========================
//       if (option) {
//         state.selectedOptionsWithValues[variantName] = {
//           id: option.categoryVariantOptionId,
//           value: option.optionValue,
//         };
//       }
//     },

//     setInitialSku(state, action) {
//       const { sku, selectedOptions } = action.payload;

//       // KEEP OLD LOGIC
//       state.selectedSku = sku;
//       state.selectedOptions = selectedOptions || {};

//       // RESET UI MAP SAFELY
//       state.selectedOptionsWithValues = {};
//     },

//     resetSelectedVariant(state) {
//       state.selectedOptions = {};
//       state.selectedOptionsWithValues = {};
//       state.selectedSku = null;
//     },
//   },
// });

// export const variantAction = variantSlice.actions;
// export default variantSlice;